import classes from './myaccountDetails.scss';

class MyAccountDetails extends React.Component {
    constructor(props) {
        super(props);
    }

  displayEdit(){
    if(window.location.pathname.includes(app.appUtil.getAppRoutes().BILLING.SETTINGS_PAGE) || window.location.pathname.includes(app.appUtil.getAppRoutes().MYACCOUNT.MYACCOUNT_LANDINGPAGE)){
        return <a href='javascript:' onClick={()=>{
            if(window.location.pathname.includes(app.appUtil.getAppRoutes().BILLING.SETTINGS_PAGE)){
                app.appService.setLocalStorage('updateMailingFromProfile', app.appUtil.getAppRoutes().BILLING.SETTINGS_PAGE);
            }else if(window.location.hash === '#SAoverview'){
                this.props.setSessionstorageForUpdateMailingAdd();
                app.appService.setLocalStorage('updateMailingFromProfile', app.appUtil.getAppRoutes().MYACCOUNT.MYACCOUNT_LANDINGPAGE);
            }
            app.appUtil.navigateTo(app.appUtil.getAppRoutes().PROFILE_SETTINGS.UPDATE_MAILING_ADDRESS);
        }} className={classes.anchorTag}>Edit<span className={classes.editIcon}><i aria-hidden className='fas fa-pencil-alt' /></span></a>;
    }
  }
  capitaliser(mySentence) {
    let words = mySentence ? mySentence.trim().split(" ") : [];
    mySentence ? words.length < 1 ? words.push(mySentence) : null : null;
    let reframedSentence = words.map((word) => {
        let reframed = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        return word === word.toUpperCase() ? word : reframed;
    }).join(" ");
    return reframedSentence;
}

render() {
    let myaccountDetailsSession= !_.isEmpty( app.appService.getSessionstorage("myaccountDetails")) ? app.appService.getSessionstorage("myaccountDetails") : {firstName:this.props.firstName,lastName:this.props.lastName,mailingAddress:this.capitaliser(this.props.mailingAddrsDetails),contractAccountNumber:this.props.contractAccountNumber};
        const displayName = `${myaccountDetailsSession.firstName} ${myaccountDetailsSession.lastName}`;
        const displayEdit = this.displayEdit(); 
    return (
        <div>
            <div className={classes.sceAccDetails + ''}>
                <div>
                    <div>
                        <div className={classes.sceAccDetailsAlignment}>
                            <div>
                                <div className={classes.sceAccEachSec}>
                                    <div className={classes.sceAccMblHiddenLabel}>Customer Name</div>
                                    <div data-pii-encrypt className={classes.sceAccHeader}>{displayName}</div>
                                </div>
                            </div>
                            <div>
                                <div className={classes.sceAccEachSec}>
                                    <div className={classes.sceAccMblHiddenLabel}>Mailing Address</div>
                                    <div data-pii-encrypt className={classes.sceAccAddress}>{myaccountDetailsSession.mailingAddress} {displayEdit}</div>
                                </div>
                            </div>
                            <div>
                                <div className={[classes.sceAccEachSec, classes.sceAccContractDetails].join(", ")}><div className={classes.sceAccContractHeader}>Customer Account<span className={classes.sceLabelColon}>:&nbsp;</span></div><div data-pii-encrypt className={classes.sceAccContractNumber}>{myaccountDetailsSession.contractAccountNumber}</div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
}

export default MyAccountDetails;